import { db } from '@/api/firebase';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useMainContext } from '@/context/main-context';
import { addDoc, collection } from 'firebase/firestore';
import { useForm } from 'react-hook-form';

const AddRoomForm = () => {
  const { uid, activeBranchId } = useMainContext();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      capacity: '',
    },
  });

  const onSubmit = async (data) => {
    try {
      await addDoc(collection(db, `users/${uid}/rooms`), {
        name: data.name,
        capacity: Number(data.capacity),
        branchId: activeBranchId,
        createdAt: new Date(),
      });

      reset();
      alert('Room added successfully!');
    } catch (err) {
      console.error(err);
      alert('Error adding room');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="space-y-2">
        <Label>Room Name</Label>
        <Input
          type="text"
          {...register('name', { required: 'Room name is required' })}
          placeholder="e.g. Room 101"
        />
        {errors.name && (
          <p className="text-red-500 text-sm">{errors.name.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label>Capacity</Label>
        <Input
          type="number"
          {...register('capacity', {
            required: 'Capacity is required',
            min: { value: 1, message: 'Capacity must be at least 1' },
          })}
          placeholder="e.g. 25"
        />
        {errors.capacity && (
          <p className="text-red-500 text-sm">{errors.capacity.message}</p>
        )}
      </div>

      <Button type="submit" className="w-full">
        Save Room
      </Button>
    </form>
  );
};

export default AddRoomForm;
